/**
 * Factory functions that return empty sub-objects for settings forms.
 *
 * Centralised here to avoid duplicating these definitions across pages and to
 * prevent drift when new fields are added to the shared types.
 */
import type { BusinessInformation, ContactInformation } from '../model/settingsTypes';

export function emptyContactInformation(): ContactInformation {
  return {
    phone: '',
    email: '',
    telegram: '',
    website: '',
  };
}

export function emptyBusinessInformation(): BusinessInformation {
  return {
    storeName: '',
    timezone: '',
    currency: '',
    locale: '',
    logoUrl: '',
  };
}
